export default __webpack_public_path__ + "static/media/Flag_of_France.31c85019.svg";